export default __webpack_public_path__ + "static/media/arc-circle-gradient.08ab130a.svg";